import React from "react";
import { FormProvider } from "react-hook-form";
import { Edit } from "@refinedev/mui";

import { CompanyForm } from "@modules/companies/components/CompanyForm";
import { useCompanyEditForm } from "./controller";

export const CompanyEdit = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending, formLoading, id } = useCompanyEditForm();

  return (
    <Edit
      recordItemId={id}
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <CompanyForm />
      </FormProvider>
    </Edit>
  );
});
